import BasePage from "../../base/BasePage";
import { Button } from "nq-component";
import NavBar from "../../components/navigation";
import React from "react";
import { addSchemaUseCase } from "../../usecases/schema/usecases";
import DashboardMainPresenter from "./DashboardMainPresenter";
import CardView from "../../components/common/CardView";
import ManagerCounter from "./components/ManagerCounter/ManagerCounter";
import ManageTimeInOut from "../../components/TimeManagement";
import TimeTable from "../EmployeeSelfService/TimeManagement/time-management-table/TimeTable";
import { findObjectUseCase } from "../../usecases/object";
import { Calendar } from "antd";
import withRouter from "../../withRouter";
import { getCurrentUserUseCase } from "../../usecases/user";
import MainpageNotice from "./components/Notice/MainpageNotice";

class DashboardMain extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new DashboardMainPresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
      currentDate: new Date(),
      accessPass: false,
      dailyTime: [],
      buttonLabel: "TIME-IN",
      isDisable: false,
    };
    this.childRef = React.createRef();
  }

  async componentDidMount() {
    await this.fetchDailyTimeRecord();
  }

  getCurrentDate() {
    const now = new Date();
    const options = {
      weekday: "long",
      month: "short",
      day: "numeric",
      year: "numeric",
    };
    return now.toLocaleDateString("en-US", options);
  }

  async fetchDailyTimeRecord() {
    // const employeeID = this.getCurrentUser().employee.id;
    const employeeID = await getCurrentUserUseCase().execute();
    console.log("EMP : ", employeeID);

    const records = await findObjectUseCase().execute("employees", {
      where: { id: employeeID.employee.id },
      keys: [
        "hired",
        "position",
        "position.position_title",
        "nonRegPosition",
        "nonRegPosition.positionTitle",
      ],
      include: ["position"],
    });
    const hired = records[0]?.hired ? new Date(records[0].hired) : null;
    const now = new Date();

    let lengthOfService = null;
    if (hired) {
      let years = now.getFullYear() - hired.getFullYear();
      let months = now.getMonth() - hired.getMonth();
      let days = now.getDate() - hired.getDate();

      if (days < 0) {
        months -= 1;
        days += new Date(now.getFullYear(), now.getMonth(), 0).getDate();
      }
      if (months < 0) {
        years -= 1;
        months += 12;
      }

      const parts = [];
      if (years > 0) parts.push(`${years} ${years !== 1 ? "years" : "year"}`);
      if (months > 0)
        parts.push(`${months} ${months !== 1 ? "months" : "month"}`);
      if (days > 0) parts.push(`${days} ${days !== 1 ? "days" : "day"}`);

      if (parts.length > 1) {
        const last = parts.pop();
        lengthOfService = parts.join(", ") + " and " + last + " ago";
      } else {
        lengthOfService = (parts[0] || "0 days") + " ago";
      }
    }
    this.setState({
      position:
        records[0]?.position?.position_title ||
        records[0]?.nonRegPosition?.positionTitle,
      lengthOfService,
    });
  }

  handleAccessPass = (access) => {
    this.setState({ accessPass: access });
  };

  closeHandlePass = () => {
    this.setState({ accessPass: false });
  };

  handleDailyTimeUpdate = (data) => {
    this.setState({ dailyTime: data });
  };

  refetchData = () => {
    this.childRef.current.refetchData();
  };

  handleBtnNav(location) {
    this.navigateTo(`/${location}`);
  }

  render() {
    const onPanelChange = (value, mode) => {
      console.log(value.format("YYYY-MM-DD"), mode);
    };
    return (
      <>
        <div
          className={`container-fluid d-flex flex-column ${
            this.isMobile() ? "pt-5" : "p-5"
          }`}
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1.5px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "1rem" }}>You are here: Dashboard</p>
          </div>

          <div className="row">
            <div className="col-lg-6 ">
              <ManageTimeInOut
                dailyTime={this.state.dailyTime}
                refetchData={this.refetchData}
                buttonLabel={this.state.buttonLabel}
                isDisable={this.state.isDisable}
              />
              <div className="d-none">
                <TimeTable
                  ref={this.childRef}
                  accessPass={this.handleAccessPass}
                  updateDailyTime={this.handleDailyTimeUpdate}
                />
              </div>
            </div>

            <div className="col-lg-6 mb-3">
              <CardView>
                <div className="d-flex justify-content-center h-100">
                  <Calendar
                    fullscreen={false}
                    style={{
                      width: 750,
                    }}
                    onPanelChange={onPanelChange}
                  />
                </div>
              </CardView>
            </div>
          </div>
          <CardView icons={"/events.svg"}>
            {(this.state.position || this.state.lengthOfService) && (
              <div style={{ marginRight: "auto" }}>
                {this.state.position && (
                  <h3>
                    You are currently assigned as{" "}
                    <span className="text-primary fw-bolder">
                      {this.state.position}
                    </span>
                  </h3>
                )}
                {this.state.lengthOfService && (
                  <h3>Length of Service: {this.state.lengthOfService}</h3>
                )}
              </div>
            )}
          </CardView>

          <div className="row">
            <div className="col-lg-6 mb-3 mt-3" style={{ height: "200px" }}>
              <CardView
                style={{
                  backgroundColor: "rgb(129, 216, 208)",
                  color: "white",
                }}
              >
                <h3>Leave Request</h3>
                <div className="d-flex justify-content-center align-items-end h-100">
                  <Button
                    progress={this.state.progress}
                    className="btn btn-primary w-75"
                    onClick={() => this.handleBtnNav("lmanagement")}
                  >
                    Leave Request
                  </Button>
                </div>
              </CardView>
            </div>
            <div className="col-lg-6 mb-3 mt-3" style={{ height: "200px" }}>
              <CardView
                style={{
                  backgroundColor: "rgb(137, 207, 240)",
                  color: "white",
                }}
              >
                <h3>Monthly Attendance</h3>
                <div className="d-flex justify-content-center align-items-end h-100">
                  <Button
                    progress={this.state.progress}
                    className="btn btn-primary w-75"
                    onClick={() => this.handleBtnNav("tmanagement")}
                  >
                    View Time Sheet
                  </Button>
                </div>
              </CardView>
            </div>
            {/* <div className="col-lg-4 mb-3 mt-3" style={{ height: "200px" }}>
              <CardView
                style={{
                  backgroundColor: "rgb(89, 139, 174)",
                  color: "white",
                }}
              >
                <h3>Over Time</h3>
                <div className="d-flex justify-content-center align-items-end h-100">
                  <Button
                    progress={this.state.progress}
                    className="btn btn-primary w-75"
                    onClick={() => this.handleBtnNav("overtime")}
                  >
                    Apply For OverTime
                  </Button>
                </div>
              </CardView>
            </div> */}
          </div>
          <div className="d-flex justify-content-center mb-3">
            <ManagerCounter />
          </div>
          <div className="d-flex justify-content-center">
            <MainpageNotice />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(DashboardMain);
